const getters = { 
  token: state => state.user.token, 
  userInfo: state => state.user.info,
  ifyik:  state => state.sysParams.ifyik,				// 医卡模式（0：无卡，1：有卡）
  iffsd:  state => state.sysParams.iffsd,				// 分时段挂号（0：停用，1：启用）
  ifyyorqhpay:  state => state.sysParams.ifyyorqhpay,	// 预约或取号支付（0：预约，1：取号）
  ifksorysgh:  state => state.sysParams.ifksorysgh,		// 挂号模式（0：科室，1：专家）
  ifmenzth: state => state.sysParams.ifmenzth,			// 门诊退号（0：停用，1：启用）
  ifdzjkk: state => state.sysParams.ifdzjkk,			// 电子健康卡（0：停用，1：启用）
  ifybmzgh: state => state.sysParams.ifybmzgh,			// 医保移动支付门诊挂号（0：停用，1：启用）
  ifybmzjf: state => state.sysParams.ifybmzjf,			// 医保移动支付门诊缴费（0：停用，1：启用）
}

export default getters
